import React from "react";

const Loader = ({ message = "Loading data..." }) => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5 my-3">
      <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 text-secondary fw-semibold">{message}</p>
    </div>
  );
};

export default Loader;
